import {MtplQuotation} from "../../../../model/quotation";
import {strings} from "../../../../strings/strings";
import {DocumentType, DocumentTypeMap} from "../../../../model/document";
import {SelectOption} from "../../../../components/inputs/SelectAutocompleteOld";

export const shouldShowNewContent = (): boolean => {
    const getUTCPlus2Time = (date: Date): Date => {
        const utcTimestamp = date.getTime() + date.getTimezoneOffset() * 60 * 1000;
        return new Date(utcTimestamp + 2 * 60 * 60 * 1000);
    };

    const currentDate = getUTCPlus2Time(new Date());
    const switchDate = getUTCPlus2Time(new Date('2025-01-01T00:00:00'));

    return currentDate >= switchDate;
};

function getMTPLAgree1CheckboxLabel(quotation: MtplQuotation) {
    const showNewContent = shouldShowNewContent();shouldShowNewContent()
    if (quotation.cascoAdditionalCoverage.covered === true && quotation.vtplAdditionalCoverage.covered === true) {
        return showNewContent ? strings.agreementCheckbox1in2025 : strings.agreementCheckbox1;
    } else if (quotation.cascoAdditionalCoverage.covered === true) {
        return showNewContent ? strings.agreementCheckbox2in2025 : strings.agreementCheckbox2;
    } else if (quotation.vtplAdditionalCoverage.covered === true) {
        return showNewContent ? strings.agreementCheckbox3in2025 : strings.agreementCheckbox3;
    } else {
        return showNewContent ? strings.agreementCheckbox4in2025 : strings.agreementCheckbox4;
    }
}

function getMTPLAgree1SpanLabel(quotation: MtplQuotation) {
    if (quotation.cascoAdditionalCoverage.covered === true && quotation.vtplAdditionalCoverage.covered === true) {
        return strings.agreementLabel1;
    } else if (quotation.cascoAdditionalCoverage.covered === true) {
        return strings.agreementLabel1;
    } else if (quotation.vtplAdditionalCoverage.covered === true) {
        return strings.agreementLabel1;
    } else {
        return strings.agreementLabel2;
    }
}

const citiesShortcut = () => {
    return [
        { value: 'UA', label: strings.Ukraine,}
    ]
};

const formatResponseForAutocomplete = (response: any) => {
    return {
        name: response.label,
        code: response.value,
    }
}
const formatSelectedOptionForAutocomplete = (option: any) => {
    return {
        label: option?.name,
        value: option?.code
    }
}

const documentTypeOptions = Object.keys(DocumentType).map(el => {
    return {value: el, label: DocumentTypeMap[el]} as SelectOption
});

function convertContextNameFunction(name: string) {
    return name.replaceAll("-", ".").replaceAll("Party", "")
}

const Event = {
    'mtpl_online_00001_smart_drive': 'osago_emtpl_smart_conditions_extra',
    'mtpl_online_00001': 'osago_conditions_extra',
    'greenCard_0001': 'green_card_conditions_extra',
}
export {
    getMTPLAgree1CheckboxLabel,
    getMTPLAgree1SpanLabel,
    citiesShortcut,
    formatResponseForAutocomplete,
    formatSelectedOptionForAutocomplete,
    documentTypeOptions,
    convertContextNameFunction,
    Event
}